export default __webpack_public_path__ + "static/media/formulaRejected.01cc2ddb.svg";